import { render, staticRenderFns } from "./TheSnapshotTableGetData.vue?vue&type=template&id=97e87d8e&"
import script from "./TheSnapshotTableGetData.vue?vue&type=script&lang=js&"
export * from "./TheSnapshotTableGetData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports